import { useContext } from 'react'
import { css, cx, useTheme } from '@fable/theme'
import {
  Text,
  PaginationContainer,
  PaginationContainerContext,
} from '@fable/components'
import { Book, Review } from '@fable/types'
import Loader from 'components/loader'
import { BookDetailReview } from './BookDetailReview'
import { analytics } from 'segment_analytics'
import { useErrorModal } from 'hooks'

const BookDetailReviewsList = () => {
  const { colors } = useTheme()
  const { list, query, error } = useContext(PaginationContainerContext)

  useErrorModal(error)

  if (query.isLoading && !query.isFetchingNextPage) {
    return <Loader />
  }

  if (!list?.length) return null

  return (
    <div
      className={cx(
        css`
          margin-top: 24px;
        `,
        'fade'
      )}
    >
      {list?.map((review: Review) => (
        <div
          key={review.id}
          className={css`
            &:not(:last-child) {
              margin-bottom: 12px;
              padding-bottom: 24px;
              border-bottom: 1px solid ${colors.whiteSmoke};
            }
          `}
        >
          <BookDetailReview review={review} />
        </div>
      ))}
    </div>
  )
}

export const BookDetailReviewsMain = ({
  book,
  limit,
}: {
  book: Book
  limit?: number
}) => {
  const { nativeOverrides } = useTheme()

  return (
    <PaginationContainer
      scrollLevel="fullPage"
      queryArgs={['reviews', book?.id]}
      endpoint={`/books/${book?.id}/reviews`}
      limit={limit || 10}
      listEnd={
        <button
          className={css`
            ${nativeOverrides.buttonClear};
            text-align: center;
            max-width: 240px;
          `}
          onClick={() => analytics.actions.appDownloadDeeplink()}
        >
          <Text
            type="body"
            sizing="S"
            text="There are no more reviews for this book. Click here to create your own."
          />
        </button>
      }
      refetchButton
    >
      <BookDetailReviewsList />
    </PaginationContainer>
  )
}
